import { Component, signal, ChangeDetectionStrategy } from '@angular/core';
import { RouterOutlet } from '@angular/router';


import { Auth, CommonService } from './services';
import { SidebarComponent } from './pages';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';

@Component({
  selector: 'app-root',
  imports: [
    RouterOutlet,
    SidebarComponent,
    MatProgressSpinnerModule
],
  templateUrl: './app.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrl: './app.scss'
})
export class App {
  protected readonly title = signal('zignflix-admin');

  constructor(public auth: Auth, private commonService: CommonService) { }

  get showSpinner() {
    return this.commonService.showSpinner;
  }
}
